import React from "react";

export const CourseHeaderButton = ({url, onClick, text, extraStyling, disabled, tooltip}) => {

  return (
    <div className={extraStyling} title={disabled && tooltip ? tooltip : undefined}>
      <a href={url} onClick={disabled ? (e) => e.preventDefault() : onClick} className="remove_outline_for_a">
        <div className={`btsp_bullet_button btn_inline btsp_bullet_button set_outline_for_button${disabled ? ' course-header-button-disabled' : ''}`}>
          <div className="icon">
          <i className="gga-circle-plus"/>
          </div>
          <div className="btsp_align-middle">
            {text}
          </div>
        </div>
      </a>
    </div>
  )
}